import React, {useEffect, useState} from "react";
import NoDataContent from "../../../../../../components/reports/report-menu/no-data-content.jsx";
import ReportUtils from "../../../../../../utils/report-utils.js";
import projectUtils from "../../../../../../utils/project-utils.js";

const INITIAL_LIMIT = 15;
const reportId = "individuals-other-encounters"
const reportName = "Indivíduos frequentemente abordados"
const IndividualsOtherEncounters = ({data}) => {
  const [limit, setLimit] = useState(INITIAL_LIMIT);

  useEffect(() => {
    data?.length &&  ReportUtils.createExportableTable(null, null, "Ind. associados a outras abord.", reportId);
  }, [data]);

  const seeMoreOrLess = () => {
    setLimit(prev => prev ? null : INITIAL_LIMIT);
  };

  return(
    <>
      <div className="chart-report">
        <span className="chart-title">{reportName} {(data.length > limit && limit) ? ' (TOP 15)' : ''}</span>
      </div>
      {
        data.length > 0
        ?<div>
            <table id={reportId} className="table report-table" sheet-name={reportName}>
              <thead className="thead-background">
              <tr className="bg-[#f6f6f6] text-left">
                <th>CPF</th>
                <th>Nome</th>
                <th>Abordado por</th>
                <th className="w-[14%]">D/H da abordagem</th>
              </tr>
              </thead>
              <tbody>
              {(limit ? data.slice(0, limit) : data).map((el, index) => (
                <React.Fragment key={index}>
                  <tr className={`table-break-word`}>
                    <td>{projectUtils.formatCpfToView(el.cpf)}</td>
                    <td>{el.name}</td>
                    <td>{el.encounter_by}</td>
                    <td className="w-[14%]">{projectUtils.formatDate(el.dt_start, "DD/MM/YYYY hh:mm")}</td>
                  </tr>
                </React.Fragment>
              ))}
              </tbody>
            </table>
            { data.length > INITIAL_LIMIT &&
              <div className="w-full flex justify-end gap-2 print-hide">
              <span className="see-more print-hide" onClick={seeMoreOrLess}>
                { limit ? "Ver mais" : "Ver menos"}
              </span>
              </div>
            }
         </div>
          : <div className="mt-1"><NoDataContent reportData={true} data={0}/></div>
      }
      <div className="chart-divisor"></div>
    </>
  )
}

export default IndividualsOtherEncounters;